import { AuthConfig } from 'angular-oauth2-oidc';
import { env } from './environment';

type scopeType = "code" | "id_token token"
const REDIRECT_URL = window.location.origin
const SCOPE = "openid profile email offline_access"
const RESPONSE_TYPE : scopeType = "code"

export const authConfig: AuthConfig = {
  issuer: env.issuer,
  redirectUri: REDIRECT_URL,
  clientId: env.clientId,
  responseType: RESPONSE_TYPE,
  scope: SCOPE,
  showDebugInformation: true,
  useSilentRefresh: true,
  silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
  strictDiscoveryDocumentValidation: false,
  disablePKCE: false,
  oidc: true
};
